// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"40605b03","664":"a24d05fb","675":"2cb919b9"}[chunkId] + ".chunk.js";
};